import { stepWizardCreate, stepWizardDefaultOptions } from '@subaio/components'

import { ContentCenter, Page } from 'components/Layout'
import { Spinner } from 'components/Spinner'

export const StepWizard = stepWizardCreate({
	...stepWizardDefaultOptions,
	loader: {
		...stepWizardDefaultOptions.loader,
		Component: () => (
			<Page>
				<ContentCenter>
					<Spinner />
				</ContentCenter>
			</Page>
		),
	},
})
